<template>
  <div class="batch-management-subpage">
<!--    <div class="subpage-nav">-->
<!--      <div @click="goBack" class="go-back">-->
<!--        <i class="el-icon-back"></i>-->
<!--        <span class="go-back-text">返回</span>-->
<!--      </div>-->
<!--      <div class="nav-title" @click="goBack">批次管理</div>-->
<!--      <i class="el-icon-arrow-right"></i>-->
<!--      <div class="nav-active">{{ publicData.stateName }}</div>-->
<!--    </div>-->
    <div class="subpage-main">
      <gj-breadcrumb :list="breadcrumbList" @backHandle="publicData.state === 'supplement-record' ? goDeliverySupplement() : goBack()"></gj-breadcrumb>
      <ReplacementCost v-if="publicData.state === 'replacement-cost'" :selectedRowsMap="publicData.selectList" @cancel="goBack"/>
      <DeliverySupplement v-if="publicData.state === 'delivery-supplement'" :selectedRowsMap="publicData.selectList" @cancel="goBack"/>
      <SupplementRecord v-if="publicData.state === 'supplement-record'" @cancel="goDeliverySupplement"/>
    </div>
  </div>
</template>

<script>
import ReplacementCost from "modules/finance/batch-management/components/ReplacementCost.vue"
import DeliverySupplement from "modules/finance/batch-management/components/delivery-supplement.vue"
import SupplementRecord from "modules/finance/batch-management/components/supplement-record.vue"

export default {
  name: "batch-management-subpage",
  inject: ["getPublicData", "setPublicData"],
  props: {},
  components: { ReplacementCost, DeliverySupplement, SupplementRecord },
  data() {
    return {
      breadcrumbList:[]
    };
  },
  computed: {
    publicData() {
      return this.getPublicData()
    }
  },
  watch: {
    publicData:{
      handler: function (val) {
        if(this.getPublicData().state === 'supplement-record') {
          this.breadcrumbList = [
            {name: '批次补录', handle: () => {this.goBack()}},
            {name: '发货补录', handle: () => {this.goDeliverySupplement()}},
            {name: this.getPublicData().stateName || '', handle: () => {}}
          ]
        }else {
          this.breadcrumbList = [
            {name: '批次补录', handle: () => {this.goBack()}},
            {name: this.getPublicData().stateName || '', handle: () => {}}
          ]
        }
      },
      deep:true
    }
  },
  methods: {
    // 返回
    goBack() {
      this.setPublicData('state', 'main')
    },
    // 返回上一级
    goDeliverySupplement() {
      this.setPublicData('state', 'delivery-supplement')
    },
  },
  created() {
    this.breadcrumbList = [
      {name: '批次补录', handle: () => {this.goBack()}},
      {name: this.getPublicData().stateName || '', handle: () => {}}
    ]
  },
};
</script>

<style scoped lang='scss'>
.batch-management-subpage {
  height: 100%;
  display: flex;
  flex-direction: column;
  .subpage-nav {
    padding-left: 16px;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #999999;
    .go-back {
      position: relative;
      cursor: pointer;
      &:hover {
        color: #1F6EEF;
      }
      .go-back-text {
        padding: 0 12px 0 8px;
        &:after {
          content: "";
          position: absolute;
          top: 50%;
          right: 0;
          width: 1px;
          height: 12px;
          transform: translateY(-50%);
          background-color:#E4E5E6;
        }
      }
    }
    .nav-title {
      cursor: pointer;
      padding-left: 11px;
    }
    .el-icon-arrow-right {
      padding: 0 3px;
    }
    .nav-active {
      color: #333;
    }
  }
  .subpage-main {
    flex: 1;
    background: #fff;;
    border-radius: 4px;
    padding: 12px 16px 16px;
  }
}
</style>